// Headings organize the server-owned wording; clause text is never rewritten.
export function agreementTermSections(terms = "") {
  const sections = [
    {
      title: "Authority to issue",
      match: /\bmay issue\b|\bauthority to issue\b/i,
      paragraphs: [],
    },
    {
      title: "No duplicate supplier invoices",
      match:
        /supplier.*(?:will not|must not|not to|does not).*invoices|duplicate.*invoices/i,
      paragraphs: [],
    },
    {
      title: "GST registration and notification",
      match: /\bGST\b|registered/i,
      paragraphs: [],
    },
    {
      title: "Scope and value",
      match: /supplies described|determines? the value|scope|covered taxable/i,
      paragraphs: [],
    },
    {
      title: "Commencement and duration",
      match:
        /suspend|no further|retain a copy|commence|acceptance|expiry|expires|outstanding liabilities/i,
      paragraphs: [],
    },
    { title: "Additional agreement terms", paragraphs: [] },
  ];
  String(terms)
    .split(/(?<=\.)\s+/)
    .filter((text) => text.trim())
    .forEach((text) => {
      const section =
        sections.find((entry) => entry.match?.test(text)) ||
        sections[sections.length - 1];
      section.paragraphs.push(text);
    });
  return sections.filter((section) => section.paragraphs.length);
}
